import { render, staticRenderFns } from "./NewsConfigList.vue?vue&type=template&id=8aacbb0c"
import script from "./NewsConfigList.vue?vue&type=script&lang=js"
export * from "./NewsConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports